import { defineComponent, renderSlot, watch } from 'vue'
import { buildProps, definePropType } from '@sgui-plus/utils/props'
import { provideGlobalConfig, useSizeProp } from '@sgui-plus/hooks'

import type { ExtractPropTypes } from 'vue'
import type { Language } from '@sgui-plus/locale'
import type { MessageConfigContext } from '@sgui-plus/components/message'

export const messageConfig: MessageConfigContext = {}

export const configProviderProps = buildProps({
  locale: {
    type: definePropType<Language>(Object),
  },

  size: useSizeProp,

  message: {
    type: definePropType<MessageConfigContext>(Object),
  },

  zIndex: {
    type: Number,
  },

  namespace: {
    type: String,
    default: 'sg',
  },
} as const)

const ConfigProvider = defineComponent({
  name: 'SgConfigProvider',
  props: configProviderProps,

  setup(props, { slots }) {
    watch(
      () => props.message,
      (val) => {
        Object.assign(messageConfig, val ?? {})
      },
      { immediate: true, deep: true }
    )
    const config = provideGlobalConfig(props)
    return () => renderSlot(slots, 'default', { config: config?.value })
  },
})

export type ConfigProviderProps = ExtractPropTypes<typeof configProviderProps>

export type ConfigProviderInstance = InstanceType<typeof ConfigProvider>

export default ConfigProvider

